<template>
  <div class="navB">
    <div class="m_nav">
      <div class="m_nav_r">
        <ul>
          <li v-for="(item) in titleChild" :key="item.id" >
            <router-link :to="{name:item.src}" tag="a" >{{item.name}}</router-link>
            <i class="iconfont"></i>
          </li>
          <li>
            <a @click="onClickLeft">返回</a>
            <i class="iconfont"></i>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'NavB',
    props:['titleChild'],
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods:{
      onClickLeft() {
        this.$router.go(-1)
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .navB{
    width: 100%;
    height: 54px;
    position: fixed;
    top: 130px;
    left: 0;
    background-color: #fff;
    z-index: 999;
    border-top: 1px solid #979797;
  .m_nav{
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #c9c9c9;
    display: flex;
    justify-content: space-between;
    .m_nav_r{
      width: auto;
      ul{
        display: flex;
        a{
          color: #827f7f;
        }
        .router-link-exact-active{
          color: #000;
        }
        li:last-child i{
          background: none;
        }
      }
    }
  }
    .iconfont{
      display: inline-block;
      width: 16px;
      height: 16px;
      background: url(../../assets/icon/right.svg);
      background-size: contain;
      vertical-align: text-bottom;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/detailsPage/NavB.vue